import { forwardRef } from 'react';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const BreadcrumbStep = forwardRef(
  (
    {
      step,
      index,
      isActive,
      textClassName,
      activeClassName,
      inactiveClassName,
      noBrackets,
      disableClick,
      lockNext,
      items,
      labelData,
      onClick
    },
    ref
  ) => {
    const handleClick = () => {
      if (disableClick) return;
      if ((lockNext && index >= items.step) || step?.locked) return;
      onClick(index);
    };

    const rawLabel = step?.label;
    const label = typeof rawLabel === 'function' ? rawLabel(labelData) : rawLabel;
    const text = step?.title || step?.name;
    const icon = step?.icon;
    const hasText = !!text;
    const hasIcon = !!icon;
    const hasMultipleSteps = items?.steps?.length > 1;

    return (
      <div
        ref={ref}
        data-qa={`breadcrumb-step-${index}`}
        className={cn('group flex h-6 items-center whitespace-nowrap', textClassName)}
        onClick={handleClick}>
        {hasIcon && (
          <div className="flex size-6 shrink-0 items-center justify-center">
            <Icon
              icon={icon}
              size="16px"
              color="neutral"
              shade={isActive ? 800 : 700}
              className={cn(hasMultipleSteps && 'group-hover:!text-neutral-800')}
            />
          </div>
        )}
        {hasText && (
          <span
            className={cn(
              'relative select-none p-1 text-sm leading-4',
              hasMultipleSteps &&
                !isActive &&
                'cursor-pointer before:absolute before:bottom-0 before:left-0 before:h-[1px] before:w-full before:bg-neutral-800 before:opacity-0 before:duration-150 before:content-[""] hover:text-neutral-800 hover:before:opacity-100',
              isActive
                ? activeClassName || 'font-600 text-neutral-800'
                : inactiveClassName || 'font-500 text-neutral-600'
            )}>
            {text}
            {label ? (
              <span className="text-sm text-neutral-800"> {noBrackets ? label : `(${label})`}</span>
            ) : null}
          </span>
        )}
      </div>
    );
  }
);

BreadcrumbStep.displayName = 'BreadcrumbStep';

export default BreadcrumbStep;
